import { render } from "./productCard.vue?vue&type=template&id=44a01354&scoped=true"
import script from "./productCard.vue?vue&type=script&lang=ts"
export * from "./productCard.vue?vue&type=script&lang=ts"

import "./productCard.vue?vue&type=style&index=0&id=44a01354&lang=scss&scoped=true"
import "./productCard.vue?vue&type=style&index=1&id=44a01354&lang=css"
script.render = render
script.__scopeId = "data-v-44a01354"

export default script